// extracted by mini-css-extract-plugin
export default {"robot-image":"NotFoundTemplate-module--robot-image--rGcB4"};